export default __webpack_public_path__ + "static/media/ic_workspace_48px.4dc159b1.svg";